export const statuses = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
} as const
